module.exports = __webpack_public_path__ + "fonts/NunitoSans-Black.ttf";